import { takeLatest, put, call } from 'redux-saga/effects';
import appLoaderAction from '../action/app-loader-action';
import { authenType } from '../action/types';
import notifyUtitls from '../../utils/notify-utils';
import authenService from '../../services/authen-service';

function* authen(action) {
    try {
        yield put(appLoaderAction.enable());

        const authen = yield call(authenService.login, action.payload);

        const payload = authen.user;

        yield put({ type: authenType.SUCCESS, payload });

        yield put(appLoaderAction.disale());

        

    } catch (err) {
        notifyUtitls.error(err);
        yield put(appLoaderAction.disale());
    }
}

const authenSaga = [
    takeLatest(authenType.REQUEST, authen),
];

export default authenSaga;